module.exports = __webpack_public_path__ + "static/img/aqzs23.cc04d36c.jpg";